import React, { useCallback, memo } from 'react';
import { InputWithMask } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ClientCustomCalendarModel,
  ReportCurrency,
  ReportType,
  CustomCalendarPeriods,
} from '../../../../models';
import * as Styled from '../styled';
import { INPUT_MASK } from '../../../../constants';
import { validate } from '../../../../util/validation';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import ReportSettingPIT from '../ReportSettingPIT';
import { Icon } from '../../../../components';

interface ReportSettingAssetAmortProps {
  onChange: (updatedValue: ReportSettingAssetAmortState) => void;
  reportSettingState: ReportSettingAssetAmortState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT: boolean;
}

export interface ReportSettingAssetAmortState {
  selectedCurrency: SelectOption<ReportCurrency>;
  asOfAssetAmort: string;
  isValid: boolean;
}

function ReportDateSettingAssetAmort({
  onChange,
  reportSettingState,
  customCalendarSettings,
  reportTypeSetting,
  isAllowPIT,
}: ReportSettingAssetAmortProps): JSX.Element {
  const { isCustomCalendarEnabled, numberOfPeriods } = customCalendarSettings;
  const placeholder = isCustomCalendarEnabled
    ? INPUT_MASK.CUSTOM_CALENDAR_PLACEHOLDER
    : INPUT_MASK.SHORT_DATE_PLACEHOLDER;

  const mask = isCustomCalendarEnabled
    ? INPUT_MASK.CUSTOM_CALENDAR
    : INPUT_MASK.SHORT_DATE;

  const dateInputHandler = useCallback(
    (value: string): void => {
      let isValidDate;

      if (isCustomCalendarEnabled) {
        isValidDate =
          validate(value, CustomCalendarPeriods[numberOfPeriods]) === '';
      } else {
        isValidDate = validate(value, { shortDate: 'Invalid date' }) === '';
      }
      onChange({
        ...reportSettingState,
        asOfAssetAmort: value,
        isValid: isValidDate,
      });
    },
    [isCustomCalendarEnabled, onChange, reportSettingState, numberOfPeriods],
  );

  return (
    <>
      <Styled.ReportSettingRow>
        <div>
          <Icon name="calendar" />
        </div>
        <div className="shortDate">
          <InputWithMask
            placeholder={placeholder}
            required={true}
            name="asOf"
            value={reportSettingState.asOfAssetAmort}
            onChange={useCallback(
              (event): void => {
                dateInputHandler(event.target.value.trim());
              },
              [dateInputHandler],
            )}
            mask={mask}
            label="Report End Date"
          />
        </div>
      </Styled.ReportSettingRow>
      <ReportSettingPIT
        reportType={ReportType.assetAmort}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        isAllowPIT={isAllowPIT}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingAssetAmortState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingAssetAmort);
